export class LaminatedCardApplePayCreation {
  constructor(data) {
    this.applePayData = data.applePayData;
  }
}
